import {
    ShipmentItemResponse,
    ShipmentRequestAndItemResponse,
    ShipmentRequestResponse
} from '@/modules/shipments-module/services/shipments.dto'
import { StrictNullable } from '@/shared/types/app.types'
import {
    ShipmentItemStatusTypeEnum,
    ShipmentRequestStatusTypeEnum
} from '@/modules/shipments-module/services/auxiliary/shipments-auxiliary.dto'
import { store } from '@/store/store'
import moment from 'moment'

export type ShipmentsSearcherResponse = ShipmentRequestAndItemResponse | ShipmentItemResponse

export interface ShipmentsSearch {
    entitiesSelected: ShipmentsSearcherResponse[]
    sidebarSelectedOptionId: StrictNullable<string>
}

const getSubMenuBySendingDate =
    (sendingDate?: Date | string): StrictNullable<string> => {
        if (sendingDate) {
            if (moment(sendingDate).isSame(new Date(), 'day')) {
                return 'Today'
            } else if (moment(sendingDate).isSame(new Date(), 'week')) {
                return 'ThisWeek'
            } else if (moment(sendingDate).isSame(new Date(), 'month')) {
                return 'ThisMonth'
            }
        }
        return null
    }
export const getSelectedOptionIdFromShipmentStatus =
    (request?: ShipmentRequestResponse, response?: ShipmentItemResponse): StrictNullable<string> => {
        if (request?.status.code === ShipmentRequestStatusTypeEnum.AWAITING_SHIPMENT) {
            return 'shipmentsPendingToSend'
        } else if (response?.status.code === ShipmentItemStatusTypeEnum.SENT) {
            if (
                request?.status.code === ShipmentRequestStatusTypeEnum.IN_SHIPMENT &&
                request?.destinationLaboratory.labId === store.getters.labId
            ) {
                return 'shipmentsPendingToReceive'
            }

            const subMenu = getSubMenuBySendingDate(response?.shipment.sendingDate)
            if (subMenu) {
                return `shipmentsSent${subMenu}`
            }
        } else if (response?.status.code === ShipmentItemStatusTypeEnum.RECEIVED) {
            const subMenu = getSubMenuBySendingDate(response?.shipment.sendingDate)
            if (subMenu) {
                if (response?.shipment.destinationLaboratory.labId === store.getters.labId) {
                    return `shipmentsReceived${subMenu}`
                } else if (response?.shipment.originLaboratory.labId === store.getters.labId) {
                    return `shipmentsSent${subMenu}`
                }
            }
        }
        return null
    }
